import {JSX} from "react";

import Link from "next/link";

import SmartImage from "@/shared/ui/smart-image";

import {Typography} from "@/shared/ui/data-display/typography";
import {assetPath} from "@/shared/utils/asset-path";

import "@/shared/ui/data-display/cards/styles/feature-card.scss";

export type FeatureCardProps = {
    id: number;
    icon?: string;
    iconWidth?: number;
    iconHeight?: number;
    iconAlt?: string;
    title: string;
    description: string;
    badge?: boolean;
    className?: string;
    url?: string;
};

export function FeatureCard(props: FeatureCardProps): JSX.Element {
    const {icon, iconWidth = 60, iconHeight = 60, iconAlt = "Feature icon", title, description, className = "", url} = props;

    const href = url || "#";
    const isExternal = url?.startsWith("http") || url?.startsWith("mailto:") || url?.startsWith("tel:");

    return (
        <Link href={href} className={`feature-card ${className}`} {...(isExternal && {target: "_blank", rel: "noopener noreferrer"})}>
            <div className="feature-card__icon">
                {icon && <SmartImage src={icon} width={iconWidth} height={iconHeight} className="feature-card__icon-image" alt={iconAlt} />}
            </div>
            <div className="feature-card__content">
                <Typography as="div" size={{desktop: 14, mobile: 11}} weight={500} className="feature-card__title">
                    {title}
                </Typography>
                <Typography weight={400} size={{desktop: 12, mobile: 10}} lineHeight={140} color="paragraph2" as="p">
                    {description}
                </Typography>
            </div>
            <div className="feature-card__badge">
                <SmartImage src={assetPath("/images/icons/arrow-circle.svg")} width={14} height={14} alt="Badge" />
            </div>
        </Link>
    );
}
